export const localStorageItemNames = {
  user_token: "cashflow_admin_user_token",
  userID: "cashflow_admin_user_id",
  type: "type",
  typeId: "typeId",
  name: "name",
  showMessageAfterReload: "showMessageAfterReload",
  userStatus: "userStatus",
  dealerId: "dealerId",
  companyId: "companyId",
};
